import React, { useEffect, useState } from "react";
import { Context } from "../App";
import { Phase } from "../services/dayPhase";
import dawnStill from "../assets/house-dawn-poster.webp";
import dayStill from "../assets/house-day-poster.webp";
import duskStill from "../assets/house-dusk-poster.webp";
import nightStill from "../assets/house-night-poster.webp";
import RingHotspots from "./RingHotspots";

const STILLS: Record<Phase, string> = {
  dawn: dawnStill,
  day: dayStill,
  dusk: duskStill,
  night: nightStill,
};

const FADE_MS = 4000;

/**
 * The house from the front corner, matched to the time of day, with Ring's
 * devices marked on it. When the phase changes the next picture fades in over
 * the old one. (The turning videos in assets/ are kept for later.)
 */
export default function HouseScene() {
  const { phase } = React.useContext(Context);
  const [shown, setShown] = useState<Phase>(phase);
  const [previous, setPrevious] = useState<Phase | null>(null);

  useEffect(() => {
    setShown((cur) => {
      if (cur !== phase) setPrevious(cur);
      return phase;
    });
  }, [phase]);

  useEffect(() => {
    if (!previous) return;
    const id = window.setTimeout(() => setPrevious(null), FADE_MS);
    return () => window.clearTimeout(id);
  }, [previous]);

  const mounted = previous ? [previous, shown] : [shown];

  return (
    <div className="house-scene">
      {/* Exactly the picture's box, so the touch points line up with it. */}
      <div className="house-scene__frame">
        {mounted.map((p) => (
          <img
            key={p}
            className={`hub__house house-scene__still ${
              p === shown ? "is-current" : "is-leaving"
            }`}
            src={STILLS[p]}
            alt={p === shown ? `Our house at ${p}` : ""}
          />
        ))}
        <RingHotspots />
      </div>
    </div>
  );
}
